<template>
   <!--@touchmove.prevent @mousewheel.prevent-->
  <div id="app" >
    <el-container>
      <MainHeader></MainHeader>
      <el-main style="margin-top: 10px;">
        
        <div style="height:1150px;">
          <router-view></router-view>
        </div>
      </el-main>  
      <el-footer style="padding-left: 0px;padding-right: 0px; height:0px;">
      <MainFooter></MainFooter>    
      </el-footer> 
    </el-container>
  </div>
</template>

<script>  
// import MainMenu from '@/pages/mainMenu/MainMenu.vue'
import MainHeader from '@/components/mainHeader/MainHeader.vue'
import MainFooter from '@/components/mainFooter/MainFooter.vue'



export default { 
  name: "App",
  data () {
    return {
      // m9001:{//医保签到
      //   signIn:{
      //     opter_no:"FY6666",
      //     mac:"94:C6:91:94:26:EE",
      //     ip:"10.10.120.40"
      //   }
      // }
    }
  },
  computed: {
    sign_no:function(){
				return this.$store.state.ybStore.sign_no
			}
  },
  components:{
    MainHeader ,
    MainFooter
  },
  created() {
    //刷新时，将数据存储到sessionStorage中，如果用户退出浏览器，则 sessionStorage 里面的数据就消失
    const datastore = sessionStorage.getItem("datastore")

    if(datastore != null && datastore != 'undefined'){
      // console.log("123",datastore)
      this.$store.replaceState(
        Object.assign({},this.$store.state, JSON.parse(datastore))
      )

    }

    window.addEventListener('beforeunload', () => {
      sessionStorage.setItem('datastore',JSON.stringify(this.$store.state))
    })
  },
  mounted () {
    // //医保签到
    if (this.sign_no == '' ||  this.sign_no == undefined) {
      // this.$ybApis.m9001json();
      // this.$ybApis.request_yb('m9001json', this.m9001).then(res => {
      //   if (res.infcode == "0") {
      //     this.$store.dispatch('changeM9001Output', res);
      //     this.$store.dispatch('changeM9001Input', this.m9001);
      //   }
      // })
    }
    
  }
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
}

::-webkit-scrollbar {
  width: 0 !important;
}
::-webkit-scrollbar {
  width: 0 !important;height: 0;}

.el-header{
  margin-left: 10px;
  margin-right: 10px;
  margin-bottom: 5px;
  color: #333;
  text-align: center;
  border-radius: 6px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.el-main{
  margin-left: 0px;
  margin-right: 0px;

  color: #333;
  text-align: center;
  margin-bottom: 0px;
  border-radius: 10px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  /*属性值由很多,需要用到的时候读者可以去网上搜索;multiply:正片叠底模式。*/
  /*background-blend-mode: multiply;*/
  
  /*background:url('背景4.jpg') rgba(0, 0, 0, .5);#EF96C5*/
  background: linear-gradient(to bottom, #FFFFFF, #d0e6f8);
  background-size:100% 100%; 
}

body > .el-container {
  margin-bottom: 40px;
}

.el-container:nth-child(5) .el-aside,
.el-container:nth-child(6) .el-aside {
  line-height: 260px;
}

.el-container:nth-child(7) .el-aside {
  line-height: 320px;
}
.teachingvideo {
  box-shadow: rgba(0, 0, 0, 0.12) 0px 2px 4px, rgba(0, 0, 0, 0.04) 0px 0px 6px;
  text-align: center;
  height: 280px;
  border: 1px solid #eee;
  border-radius: 6px;
  
  padding: 20px;
  margin-top: 10px;

}
.breadcrumb-customer{
  font-size: 25px;
}
  .navigation-bar {
    border-radius: 4px;
    min-height: 36px;
    padding-top: 20px;
    padding-left: 20px;
    
  }

  .navigation-bar-back {
    border-radius: 20px;
    font-size: 25px; 
    min-height: 36px;
    margin-top: 10px;
  }

  .el-card__body, .el-main {
    padding: 0px;
}
</style>
